module.exports = __webpack_public_path__ + "img/messages.60170d8e.svg";